<template>
    <div class="flex gap-6 justify-center">
        <div v-for="(result, index) in filteredResults" :key="`${result.type}-${result.handle}`" class="flex gap-6 justify-center">
            <template v-if="result.type === 'suggestion'">
                <p class="mt-6" v-if="index === 0">Did you mean:</p>
                
                <p class="mt-6 cursor-pointer" @click="$emit('newsearch', result.title)">{{ result.title }}</p>
                
            </template>    
        </div>     
    
    </div>
    
</template>
<script setup>
    const props = defineProps({
        results: {
            type: Array,
            required: true
        },
        searchterm: {
            type: String,
            required: true
        }
    });

    const filteredResults = computed(() => {
        return props.results.filter(result => result.type === 'suggestion' && result.title !== props.searchterm);
    });
</script>